import {useState, useEffect} from 'react';
import Select from 'react-select';
import {CarbonCreditCreditType} from '../../../entities';
import {EditedProject} from '../EditedProject';
import {getCreditTypeName, useCarbonLookups} from '../../../providers/CarbonLookupsProvider';

export function CarbonCreditTypeSelect({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    const {CreditTypes} = useCarbonLookups();
    const [options, setOptions] = useState<CreditTypeOption[]>(null);
    const [selectedOption, setSelectedOption] = useState<CreditTypeOption>(null);

    useEffect(() => {
        setOptions(CreditTypes.map((x) => ({value: x.Id, label: x.Name})));
    }, [CreditTypes]);

    useEffect(() => {
        const selected = project.CarbonCreditCreditType.current;

        if (!options || !selected) return;

        setSelectedOption(options.find((x) => x.value === selected));
    }, [options]);

    const onChange = (e) => {
        setSelectedOption(e);
        setProjectAndValidate({
            ...project,
            CarbonCreditCreditType: project.CarbonCreditCreditType.update(e.value)
        });
    };

    return <Select value={selectedOption} onChange={(e) => onChange(e)} options={options} />;
}

export function formatCarbonCreditTypes(creditType: CarbonCreditCreditType) {
    return getCreditTypeName(creditType);
}

type CreditTypeOption = {
    value: number;
    label: string;
};
export default CarbonCreditTypeSelect;
